// extracted by mini-css-extract-plugin
export default {"wrap":"WH-z","fullWidth":"XH-z","hideOnDesktop":"YH-z","content":"ZH-z","hasOpenedNav":"_H-z","crumbsList":"aI-z","dropdownsWrap":"bI-z"};